export const getSearchApiUrl = (pastSearchBaseUrl: string): string => {
  return `${pastSearchBaseUrl}/saved-search/v1`;
};
